var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", {
      staticClass: "ban",
      staticStyle: {
        "background-image":
          "url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg')",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "g-top" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "ul",
            _vm._l(_vm.classIfyList, function (item) {
              return _c(
                "li",
                { key: item.id, class: { on: _vm.activeTab === item.id } },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "/product-center?catid=" + item.id },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActiveTab(item.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.name) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wp is-pc" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 5 } },
          [
            _c(
              "el-col",
              { staticStyle: { padding: "44px 0" }, attrs: { span: 5 } },
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "el-menu-vertical-demo",
                    attrs: {
                      "default-active": _vm.defaultActive,
                      "background-color": "#F7F7F7",
                      "text-color": "#343232",
                      "active-text-color": "#007DC7",
                      "unique-opened": true,
                    },
                    on: { select: _vm.handleSelect },
                  },
                  _vm._l(_vm.leftClassIfyList, function (item) {
                    return _c(
                      "div",
                      { key: item.id },
                      [
                        item.children && item.children.length > 0
                          ? _c(
                              "el-submenu",
                              { attrs: { index: item.id.toString() } },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("span", [_vm._v(_vm._s(item.name))]),
                                ]),
                                _vm._v(" "),
                                _vm._l(item.children, function (child) {
                                  return _c(
                                    "div",
                                    { key: child.id },
                                    [
                                      child.children &&
                                      child.children.length > 0
                                        ? _c(
                                            "el-submenu",
                                            {
                                              attrs: {
                                                index: child.id.toString(),
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "title" },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(child.name)),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                child.children,
                                                function (subChild) {
                                                  return _c(
                                                    "el-menu-item",
                                                    {
                                                      key: subChild.id,
                                                      attrs: {
                                                        index:
                                                          subChild.id.toString(),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subChild.name
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _c(
                                            "el-menu-item",
                                            {
                                              attrs: {
                                                index: child.id.toString(),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(child.name)),
                                              ]),
                                            ]
                                          ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            )
                          : _c(
                              "el-menu-item",
                              { attrs: { index: item.id.toString() } },
                              [_c("span", [_vm._v(_vm._s(item.name))])]
                            ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 19 } }, [
              _c(
                "div",
                { staticClass: "right-content" },
                [
                  _vm._l(_vm.solutionInfoList, function (item) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "solution-item" },
                      [
                        _c("div", { staticClass: "solution-title" }, [
                          _vm._v(_vm._s(item.solutionTitle)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "solution-pdf",
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(item.solutionPdf)
                              },
                            },
                          },
                          [_vm._v("产品规格书")]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.solutionInfoList.length === 0
                    ? _c("div", { staticClass: "solution-empty" }, [
                        _vm._v("暂无数据"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "wp is-mobile" }, [
      !_vm.isShowSolutionInfoList
        ? _c(
            "div",
            { staticClass: "mobile-menu" },
            _vm._l(_vm.menuListByMobile, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "mobile-menu-item",
                  on: {
                    click: function ($event) {
                      return _vm.handleSelectByMobile(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowSolutionInfoList
        ? _c("div", { staticClass: "mobile-content" }, [
            _c(
              "div",
              { staticClass: "right-content" },
              [
                _vm._l(_vm.solutionInfoList, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "solution-item" },
                    [
                      _c("div", { staticClass: "solution-title" }, [
                        _vm._v(_vm._s(item.solutionTitle)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "solution-pdf",
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(item.solutionPdf)
                            },
                          },
                        },
                        [_vm._v("产品规格书")]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.solutionInfoList.length === 0
                  ? _c("div", { staticClass: "solution-empty" }, [
                      _vm._v("暂无数据"),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cur" }, [
      _vm._v("\n        当前位置：\n        "),
      _c("a", { attrs: { href: "/" } }, [_vm._v("首页")]),
      _vm._v(">\n        "),
      _c("a", { attrs: { href: "#" } }, [_vm._v("应用中心")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }